import { useMutation } from '@tanstack/react-query';
import { getAgregatedQualifications as getAgregatedQualificationsService } from 'services/api/AgentCenterAPI';

export const useGetAgregatedQualifications = () => {
    const {
        mutateAsync: getAgregatedQualifications,
        isPending,
        ...rest
    } = useMutation({
        mutationFn: getAgregatedQualificationsService,
    });

    return { getAgregatedQualifications, isPending, ...rest };
};
